import { BillableEntitySource } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { useOfficeLeadSourcesVisibility } from "components/manage/lead-sources-settings/use-office-lead-sources-visibility";
import { TertiarynavMenu, TertiarynavMenuItem } from "components/navigation/tertiarynav";
import { trpc } from "components/rpc/trpc";
import React from "react";
import { useFeature, useRegionId } from "store/selectors/hooks";

export const RegionSettingsNav: React.FC<unknown> = () => {
    const regionId = useRegionId();
    const placementEnabled = useFeature("placement");
    const leadSourcesVisibility = useOfficeLeadSourcesVisibility();
    const trpcClient = trpc.useTRPC();
    const { data: regionFeatureTrack } = useQuery({
        ...trpcClient.feature.getRegionFeatureTrack.queryOptions({ regionId }),
    });

    const generalEnabled = regionFeatureTrack?.source === BillableEntitySource.Explicit;

    return (
        <TertiarynavMenu>
            {generalEnabled ? (
                <TertiarynavMenuItem to="/settings/region/general">
                    General
                </TertiarynavMenuItem>
            ) : null}
            <TertiarynavMenuItem to="/settings/region/invoices">
                Invoices
            </TertiarynavMenuItem>
            <TertiarynavMenuItem to="/settings/region/activity-types">
                Activity Types
            </TertiarynavMenuItem>
            {placementEnabled ? (
                <TertiarynavMenuItem to="/settings/region/communities">
                    Communities
                </TertiarynavMenuItem>
            ) : null}
            <TertiarynavMenuItem to="/settings/region/referral-tiers">
                Referrals
            </TertiarynavMenuItem>
            {leadSourcesVisibility === "shown" ? (
                <TertiarynavMenuItem to="/settings/region/lead-sources">
                    Lead Sources
                </TertiarynavMenuItem>
            ) : null}
        </TertiarynavMenu>
    );
};
